<template>
    <div class="home-wrap">
        <div class="item_wrap_main">
            <div class="item_wrap step1">
                <div class="item_btm">
                    <div class="item_tit">
                        案件云，律师的专属办公云
                    </div>
                    <div class="item_txt">无需下载部署，注册即用，让您和团队的案件管理更轻松
                    </div>
                    <div class="item_btn">
                        <span @click="jumpGuide">预约演示</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="price-section">
            <div class="section-box">
                <div class="section-box__center">
                    <div class="item">
                        <div class="lt">
                            <h3>基础版</h3>
                            <p>适合法律人士个人使用</p>
                        </div>
                    </div>
                    <a class="center-btn" href="https://oa.law086.com/register" target="_blank">立即体验</a>
                </div>
                <div class="section-box__bottom">
                    <ul class="bottom-list">
                        <li class="item clearfix" v-for="(item, index) in visible_1" :key="index">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section-box">
                <div class="section-box__center">
                    <div class="item">
                        <div class="lt">
                            <h3>个人高阶版</h3>
                            <p>适合法律人士个人使用</p>
                        </div>
                    </div>
                    <a @click="jumpGuide1" class="center-btn center-btn1" target="_blank">免费试用</a>
                </div>

                <div class="section-box__bottom">
                    <ul class="bottom-list">
                        <li class="item clearfix  item-title">
                            <span style="color: #FF9601;font-size: 15px;">个人基础版全部功能</span>
                        </li>
                        <li class="item clearfix" v-for="(item, index) in visible_2" :key="index">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section-box">
                <div class="section-box__center">
                    <div class="item">
                        <div class="lt">
                            <h3>团队版</h3>
                            <p>适合律师/法务团队使用</p>
                        </div>
                    </div>
                    <a @click="jumpGuide1" class="center-btn center-btn3" target="_blank">免费试用</a>
                </div>
                <div class="section-box__bottom">
                    <ul class="bottom-list">
                        <li class="item clearfix  item-title">
                            <span style="color: #FF9601;font-size: 15px;">个人高阶版全部功能</span>
                        </li>
                        <li class="item clearfix" v-for="(item, index) in visible_3" :key="index">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section-box" style="margin-right: 0;">
                <div class="section-box__center">
                    <div class="item">
                        <div class="lt">
                            <h3>律所版</h3>
                            <p>适合律所 / 企业使用</p>
                        </div>
                    </div>
                    <a @click="jumpGuide1" class="center-btn center-btn4" target="_blank">免费试用</a>
                </div>
                <div class="section-box__bottom">
                    <ul class="bottom-list">
                        <li class="item clearfix  item-title">
                            <span style="color: #FF9601;font-size: 15px;">团队版全部功能</span>
                        </li>
                        <li class="item clearfix" v-for="(item, index) in visible_4" :key="index">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="section-box" style="margin-right: 0;">
                <div class="section-box__center">
                    <div class="item">
                        <div class="lt">
                            <h3>企业版</h3>
                            <p>支持本地化部署或SAAS使用，适合大型企业法务使用</p>
                        </div>
                    </div>
                    <a @click="zxfwJumpGuide" class="center-btn center-btn5" target="_blank">立即咨询</a>
                </div>
                <div class="section-box__bottom">
                    <ul class="bottom-list">
                        <li class="item clearfix  item-title">
                            <span style="color: #FF9601;font-size: 15px;">企业版核心功能</span>
                        </li>
                        <li class="item clearfix" v-for="(item, index) in visible_5" :key="index">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="mg-bottom">
            <h2 class="text-left">团队版与律所版功能详细对比</h2>
            <div class="flex-row header-bg">
                <div class="flex-1">功能</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in collaborate_1" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>
            <div class="flex-row header-bg">
                <div class="flex-1">高级权益</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in collaborate_2" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>
            <div class="flex-row header-bg">
                <div class="flex-1">团队协作</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in collaborate_3" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>
            <div class="flex-row header-bg">
                <div class="flex-1">律所管理</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in collaborate_4" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>

        </div>


        <div class="mg-bottom pd-top-60">
            <h2 class="text-left">基础版与个人高阶版功能详细对比</h2>
            <div class="flex-row header-bg">
                <div class="flex-1">功能</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in pagePerson" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>
            <div class="flex-row header-bg">
                <div class="flex-1">高级权益</div>
                <div class="width-200 font-size-36"></div>
                <div class="width-200 font-size-36"></div>
            </div>
            <div class="flex-row" v-for="(item, index) in seniorPerson" :key="index">
                <div class="flex-1 item-title">{{ item.name }}</div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.foundation == true"></i>
                    <span v-else>{{ item.foundation }}</span>
                </div>
                <div class="width-200">
                    <i class="iconfont icon-duihao- color-50CF99" v-if="item.senior == true"></i>
                    <span v-else>{{ item.senior }}</span>
                </div>
            </div>

        </div>
        <nowdownload />
        <Footer />
    </div>
</template>

<script>
import nowdownload from '@/components/nowdownload/index'
import { Footer } from '@/components'
export default {
    name: 'home',
    components: {
        nowdownload,
        Footer
    },
    data() {
        return {
            showPop: false,
            tabIndex: 0,
            visible_1: [
                { name: '工作台概览' },
                { name: '案件管理' },
                { name: '项目管理' },
                { name: '客户管理' },
                { name: '工作日程' },
                { name: '任务记录' },
                { name: '日程提醒' },
                { name: '文档管理' },
                { name: '智能文书' },
                { name: '服务报告' },
                { name: 'AI 智能助手' },
                { name: '批量导入/导出' },
                { name: '费用工具' },
                { name: '法律网站导航' },
                { name: '通知公告' },
                { name: '移动办公（小程序、app）' },
                { name: '单文件上传限【10M】' },
            ],
            visible_2: [
                { name: 'AI 智能填充' },
                { name: '案件报告' },
                { name: '案件日期提醒' },
                { name: '案件时间轴' },
                { name: '个性化字段配置' },
                { name: '日程订阅同步' },
                { name: '合同发票管理' },
                { name: '文档在线编辑' },
                { name: '台账导出' },
                { name: '财务管理' },
                { name: '数据统计' },
                { name: '知识库' },
                { name: '共享协作' },
                { name: '个人名片' },
                { name: '单文件上传限【100M】' },
            ],
            visible_3: [
                { name: '工作台概览' },
                { name: '案件管理' },
                { name: '项目管理' },
                { name: '客户管理' },
                { name: '工作日程' },
                { name: '任务记录' },
                { name: '日程提醒' },
                { name: '日程订阅同步' },
                { name: '文档管理' },
                { name: '智能文书' },
                { name: '个性化字段配置' },
                { name: 'AI智能填充' },
                { name: '服务报告' },
                { name: '团队财务管理' },
                { name: '团队数据统计' },
                { name: '团队知识共享' },
                { name: '团队协同办案' },
                { name: '团队模板共享' },
                { name: '成员动态记录' },
                { name: '团队权限管控' },
                { name: '单文件上传限【100M】' },
            ],
            visible_4: [
                { name: '立案立项申请' },
                { name: '利益冲突检索' },
                { name: '律所存量案件导入' },
                { name: '日程跨组织协作' },
                { name: '律所财务管理' },
                { name: '律所数据统计' },
                { name: '在线申请/审批' },
                { name: '审批流程管理' },
                { name: '审批文件管理' },
                { name: '电子签印章管理' },
                { name: '律所案号设置' },
                { name: '律所团队管理' },
                { name: '律所权限管理' },
                { name: '律所公告' },
                { name: '律所名片管理' },
                { name: '单文件上传【大小不限】' },
            ],
            visible_5: [
                { name: '纠纷/案件上报' },
                { name: '案件分配与委外' },
                { name: '办案过程记录' },
                { name: '案件费用与收款' },
                { name: '案件文档管理' },
                { name: '案件台账导出' },
                { name: '结案/归档审批' },
                { name: '待开庭等事项提醒' },
                { name: '法务团队日程管理' },
                { name: '法律供应商管理' },
                { name: '代理人账号管理' },
                { name: '代理人案件协作' },
                { name: '数据统计与报表' },
                { name: 'OCR文字识别' },
                { name: '钉钉/飞书/企微集成' },
                { name: '内部OA系统对接' },
                { name: '组织架构同步' },
                { name: '人员角色权限管理' },
                { name: '系统字段个性化设置' },
                { name: '审批流程配置' },
                { name: '支持个性化需求二开' },
            ],

            pagePerson: [
                {
                    name: '工作台',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件信息录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '非诉项目信息录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '客户线索录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '工作日程管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: 'AI案件智能填充',
                    foundation: '限20次',
                    senior: true,
                },
                {
                    name: '办理过程记录',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '文档上传',
                    foundation: '单文件上传限[10M]',
                    senior: '单文件上传限【100M】',
                },
                {
                    name: '法律文书生成',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '当事人库',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '结案与归档',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '服务报告导出',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件/项目关联管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '合同发票管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '客户转案件',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '回收站',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '保全续封',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '批量导入/更新',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '日程导入/导出',
                    foundation: true,
                    senior: true,
                }
            ],
            seniorPerson: [
                {
                    name: '案件/项目/客户财务管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '案件报告',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '案件时间轴',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '案件字段提醒',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '文档在线预览与编辑',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '自定义添加字段',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '台账导出',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '跨组织协作共享',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '日程订阅同步',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: 'AI法律问答',
                    foundation: '每天限20次',
                    senior: '不限次数',
                },
                {
                    name: 'AI语音创建日程',
                    foundation: '每天限20次',
                    senior: '不限次数',
                },
                {
                    name: '财务模块',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '统计模块',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '知识库模块',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '名片管理',
                    foundation: '-',
                    senior: true,
                },
            ],
            collaborate_1: [
                {
                    name: '工作台',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件信息录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '非诉项目信息录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '客户线索录入',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '工作日程管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: 'AI案件智能填充',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '办理过程记录',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '文档上传',
                    foundation: '单文件上传限[100M]',
                    senior: '不限',
                },
                {
                    name: '法律文书生成',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '当事人库',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '结案与归档',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '服务报告导出',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件/项目关联管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '合同发票管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '客户转案件',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '回收站',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '保全续封',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '批量导入/更新',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '日程导入/导出',
                    foundation: true,
                    senior: true,
                },
            ],
            collaborate_2: [
                {
                    name: '案件/项目/客户财务管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件报告',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件时间轴',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '案件字段提醒',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '文档在线预览与编辑',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '自定义添加字段',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '台账导出',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '跨组织协作共享',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '日程订阅同步',
                    foundation: true,
                    senior: true,
                },
                {
                    name: 'AI法律问答',
                    foundation: '不限次数',
                    senior: '不限次数',
                },
                {
                    name: 'AI语音创建日程',
                    foundation: '不限次数',
                    senior: '不限次数',
                },
            ],
            collaborate_3: [
                {
                    name: '分配与协作（案件/项目/客户）',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '模板共享（办案阶段、文档目录、文档模板）',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '文档协同编辑',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '日程评论',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '团队日程共享',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '团队财务管理',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '团队数据统计',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '团队知识共享',
                    foundation: true,
                    senior: true,
                },
                {
                    name: '团队权限管理',
                    foundation: true,
                    senior: true,
                }
            ],
            collaborate_4: [
                {
                    name: '立案立项申请',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '利益冲突检索',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所存量案件/项目批量导入',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '日程跨组织协作',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所知识库管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所财务管理（开票、收款、费用和台账）',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所数据统计',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '审批文件管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '电子签印章管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所公告',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所案号设置',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '审批流程管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所成员动态',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所名片管理',
                    foundation: '-',
                    senior: true,
                },
                {
                    name: '律所权限管理',
                    foundation: '-',
                    senior: true,
                }
            ]

        }
    },
    created() {
    },
    methods: {
        jumpGuide() {
            //this.$router.push({name:'Contact'});
            window.location = "http://oalaw86com.mikecrm.com/8nB6eWV";

        },
        jumpGuide1() {
            this.$router.push({ name: 'Contact' });
        },

        zxfwJumpGuide() {
            //this.$router.push({name:'Contact'});
            // window.location = "http://oalaw86com.mikecrm.com/0OvcIFQ";
            // 企业版立即咨询的跳转应该跳转新链接了
            let url = "https://www.xfawu.com/contact-form?collect_id=03qB1yAn&from=law086";
            const urlParams = new URLSearchParams(window.location.search);
            ['reg_from', 'qd_code', 'key_word'].forEach(key => {
                const val = urlParams.get(key) || sessionStorage.getItem(key);
                if (val) {
                    url += `&${key}=${encodeURIComponent(val)}`;
                }
            });
            window.location.href = url;
        },
        openPop() {
            this.showPop = true;
        },
        popMove(e) {
            //阻止弹窗在手机上穿透移动
            e.preventDefault();
        },
        tabChange(index) {
            this.tabIndex = index
        }
    }
}
</script>
<style scoped lang="stylus">
    .item_wrap_main{
            background: linear-gradient(90deg, #F3F5FA 0%, #ECF0F7 100%);
        }
    .item_wrap{
        
        &.step1{
            background-image: url("../../public/images/price/new/banner.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position-x: 30%;
            /* min-height: 1000px; */
            display: flex;
            align-items: flex-end;
            width: 100%;
        }
        .item_imgbox{
        padding: 65px 65px 60px;
        
        }
        .item_btm{
            //background: #F2F3F5;
            padding: 128px 0 128px 0;
            width: 100%;
            .item_tit{
                font-size: 48px;
                font-weight: 800;
                color: #303443;
                line-height: 58px;
                text-align: center;
                
            }
            .item_txt{
                font-size: 26px;
                font-weight: 500;
                color: #5E606B;
                line-height: 46px;;
                padding: 39px 35px 70px;
                text-align: center;
            }
            .item_btn{
                display: flex;
                justify-content: center;
                span{
                    width: 228px;
                    height: 80px;
                    background: #FABA4A;
                    border-radius: 10px;
                    color: #fff;
                    font-size: 30px;
                    font-weight: bold;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
.price-section {
  text-align: center;
  padding: 100px 96px 50px;
}
.price-section .section-box:nth-of-type(1) .section-box__center {
  background: url("../assets/images/version_1.png") center no-repeat;
  background-size: 100%;
  h3{
    color:#000;
    font-size: 36px;
    text-align: left;

  }
  p{
    margin-top: 20px;
    font-size: 24px;
    color: #000;
    text-align: left;
  }
}
.price-section .section-box:nth-of-type(2) .section-box__center {
    background: url("../assets/images/version_2.png") center no-repeat;
    background-size: 100%;
    h3{
        color:#fff;
        font-size: 36px;
        text-align: left;
  
    }
    p{
        margin-top: 20px;
        font-size: 24px;
        color: #fff;
        text-align: left;
    }
    .center-btn1{
        background: #fff;
        border: 0;
    }
}
.price-section .section-box:nth-of-type(3) .section-box__center {
    background: url("../assets/images/version_3.png") center no-repeat;
    background-size: 100%;
    h3{
        color:#DF9E57;
        font-size: 36px;
        text-align: left;

    }
    p{
        margin-top: 20px;
        font-size: 24px;
        color: #DF9E57;
        text-align: left;
    }
    .center-btn3{
        background: #fff;
        border: 0;
    }
}

.price-section .section-box:nth-of-type(4) .section-box__center {
    background: url("../assets/images/version_4.png") center no-repeat;
    background-size: 100%;

    h3{
        color:#fff;
        font-size: 36px;
        text-align: left;

    }
    p{
        margin-top: 20px;
        font-size: 24px;
        color: #fff;
        text-align: left;
    }
    .center-btn4{
        background: #fff;
        border: 0;
    }
}

.price-section .section-box:nth-of-type(5) .section-box__center {
    background: url("../assets/images/version_5.png") center no-repeat;
    background-size: 100%;
    h3{
        color:#F4DEBC;
        font-size: 36px;
        text-align: left;
    }
    p{
        margin-top: 20px;
        font-size: 24px;
        color: #DBDBDB;
        text-align: left;
    }
    .center-btn5{
        background: #fff;
        border: 0;
    }
}
.text-left{
    font-size: 36px;
    text-align: left;
    font-weight: bold;
    margin:0 30px
}
.flex-row {
    display: flex;
    margin: 40px 30px;
    flex-dection: row;

    font-size:36px
    .flex-1{
        flex:1;
        font-weight: bold;
    }
    .item-title{
        font-weight:400;
        font-size:24px
        line-height:30px
     }
    .width-200{
        width:200px;
        align-items: center;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        i{
            font-size: 24px;
        }
    }
    .font-size-36{
        font-size: 36px
    }
}
.header-bg{
    background: #F4F5F5;
    padding: 30px;
}
.color-50CF99{
    color:#50CF99;
}
.pd-top-60{
    margin-top: 60px;
}

.price-section .section-box {
  display: inline-block;
  vertical-align: middle;
  margin-right: 30px;
  box-shadow: 0px 4px 10px 0px rgba(102, 102, 102, 0.2);
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 60px;
}
.price-section .section-box__top {
  width: 278px;
  height: 103px;
  padding-top: 26px;
  padding-bottom: 30px;
  color: #505050;
  background: -webkit-linear-gradient(#FFFFFF, #FBFBFB);
  /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#FFFFFF, #FBFBFB);
  /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#FFFFFF, #FBFBFB);
  /* Firefox 3.6 - 15 */
  background: linear-gradient(#FFFFFF, #FBFBFB);
  /* 标准的语法 */
}
.price-section .section-box__top h3 {
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 10px;
}
.price-section .section-box__top p {
  font-size: 14px;
}
.price-section .section-box__center {
  position: relative;
  //height: 278px;
  padding: 30px;
  background-color: #fff;
  border-bottom: 1px solid  #EDECEB;
}
.price-section .section-box__center .old-price {
  width: 100%;
  color: #999;
  font-size: 14px;
  text-align: center;
  position: absolute;
  top: 150px;
}
.price-section .section-box__center h3 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
}
.price-section .section-box__center .center-text {
  font-size: 14px;
  color: #303443;
}
.price-section .section-box__center .center-text strong {
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #303443;
}
.price-section .section-box__center .center-btn {
    height: 70px;
    border: 1px solid #FABA4A;
    border-radius: 10px;
    width: 100%;
    display: flex;
    font-size: 30px;
    font-weight: bold;
    color: #FABA4A;
    align-items: center;
    justify-content: center;
    margin: 70px 0 0;
}

.price-section .section-box__center .center-btn2 {
  background: #fff;
  border-color: #fff;
}
.price-section .section-box__center .center-btn3 {
  border-color: #fff;
  background: #fff;
}
.price-section .section-box__center .center-icon {
  position: absolute;
  top: 25px;
  width: 100%;
}
.price-section .section-box__center .center-icon i {
  font-size: 20px;
  color: #EC5050;
}
.price-section .section-box__center .center-icon span {
  font-size: 18px;
  color: #FF7F01 ;
}
.price-section .section-box__center .center-done {
  position: absolute;
  text-decoration: line-through;
  width: 100%;
  bottom: 130px;
  color: #999;
}
.price-section .section-box__bottom {
  box-sizing: border-box;
  //height: 1410px;
  text-align: left;
  font-size: 14px;
  padding: 40px 24px 100px;
}
.price-section .section-box__bottom .bottom-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5D5F6A;
}
.price-section .section-box__bottom .bottom-title span {
  font-size: 30px;
  padding: 0 3px;
  border-bottom: 5px solid #FABA4A ;
}
.price-section .section-box__bottom .item {
  padding-top: 50px;
  padding-left: 45px;
  position: relative;
}
.price-section .section-box__bottom .item::before {
  content: '\e75b';
  font-family: "iconfont";
  position: absolute;
  left: 0;
  font-size: 30px;
  bottom: 0;
  color: #50CF99;
}
.price-section .section-box__bottom .item.item-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF9600;
}
.price-section .section-box__bottom .item.item-title::before {
  content: '\e651';
  font-family: "iconfont";
  position: absolute;
  left: 0;
  font-size: 11px;
  bottom: 2px;
  color: #ffc000;
}
.price-section .section-box__bottom .item span {
  float: left;
  color: #333;
  font-size: 26px;
}
.price-section .section-box__bottom .second-item {
  margin-bottom: 38px;
}
.price-section .section-box__bottom .second-item .dot-wrap {
  font-size: 26px;
  color: #5D5F6A;
  float: left;
  padding-left: 20px;
}
.price-section .section-box__bottom .second-item .dot-wrap .dot {
  color: #666;
  padding-left: 7px;
  padding-right: 3px;
  font-size: 40px;
  vertical-align: middle;
}
.price-section .section-box__bottom .second-item .iconfont {
  float: right;
  font-size: 18px;
  color: #666;
}
.dialog-box-price {
  display: none;
  /* 默认隐藏 */
  position: fixed;
  left: 0;
  top: 0;
  /*设置弹窗位置*/
  padding-top: 200px;
  padding-bottom: 300px;
  /*浮在全屏上*/
  width: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;
  z-index: 999;
}
.dialog-price {
  position: relative;
  display: inline-block;
  padding: 0 20px;
  width: 830px;
  border-radius: 10px;
  background-color: #fff;
}
.dialog-price-top {
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.dialog-price-top__icon {
  display: inline-block;
  float: right;
  cursor: pointer;
}
.dialog-price .price-ewm {
  width: 476px;
  height: 478px;
  background: url('../../public/images/price/new/price_ewm.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
}
.dialog-price .price-ewm p {
  font-size: 18px;
  line-height: 28px;
}
.pt50{
    padding-top: 50px;
}
</style>
